import React from "react";
import { callApi } from "../../utils/api";
import { OriginalPresent } from "./ManageOriginalPresent";
import { ToastsStore } from "react-toasts";

declare var $: any;
interface AllProps {
  selectedOriginalPresent: OriginalPresent;
  listOriginalPresent: any;
}
class AddOriginalPresent extends React.Component<AllProps> {
  state = {
    originalPresentdetail: { id: 0, originalPresent_id: 0, name: "" },
    isLoading: false
  };
  componentWillReceiveProps(nextState) {
    this.setState({ originalPresentdetail: nextState.selectedOriginalPresent });
  }
  handleChange = (e: any) => {
    const originalPresentdetail: any = { ...this.state.originalPresentdetail };
    originalPresentdetail[e.target.name] = e.target.value;
    this.setState({ originalPresentdetail });
  };
  handleSaveResponse = (response: any) => {
    if (
      response.result === false ||
      (response.message && response.message.indexOf("Already Exist") !== -1)
    ) {
      ToastsStore.error(response.message || "Failed to save Original Present");
      return;
    }
    this.props.listOriginalPresent();
    $("#originalPresent-form").modal("hide");
    ToastsStore.success(response.message || "Original Present saved successfully");
  };
  saveOriginalPresent = () => {
    if (this.state.isLoading) {
      return;
    }
    const originalPresentdetail: any = { ...this.state.originalPresentdetail };
    originalPresentdetail.name = originalPresentdetail.name
      ? originalPresentdetail.name.trim()
      : "";
    if (!originalPresentdetail.name) {
      ToastsStore.error("Original Present name is required");
      return;
    }
    this.setState({ isLoading: true, originalPresentdetail }, () => {
      setTimeout(() => {
        const payload = { ...this.state.originalPresentdetail };
        const savePromise = payload.id
          ? callApi("POST", "original_update.php", {
              ...payload,
              id: Number(payload.id)
            })
          : callApi("POST", "original_create.php", payload);

        savePromise
          .then(res => res.data)
          .then(response => {
            this.handleSaveResponse(response);
          })
          .catch(err => {
            console.log(err);
            ToastsStore.error("Something went wrong, please try again");
          })
          .finally(() => {
            this.setState({ isLoading: false });
          });
      }, 0);
    });
  };
  render() {
    return (
      <div
        className="modal fade"
        id="originalPresent-form"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Original Present Form</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label className="col-form-label">Original Present Name:</label>{" "}
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Original Present Name"
                    onChange={e => {
                      this.handleChange(e);
                    }}
                    value={
                      this.state.originalPresentdetail.name
                        ? this.state.originalPresentdetail.name
                        : ""
                    }
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.saveOriginalPresent}
                disabled={this.state.isLoading}
              >
                {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddOriginalPresent;
